<template>
    <div class="row">
        <div class="col-12 clearfix mb-3">
            <button type="button" class="btn btn-brand pull-left" @click.prevent="createNew">{{ uLang('app.add_type', { type: lang('app.type') }) }}</button>
            <button type="button" class="btn btn-danger pull-right" @click.prevent="deleteCurrent"
                    :disabled="!id || !type.deletable" :title="delete_button_title">{{ uLang('app.delete_type', { type: lang('app.type') }) }}</button>
        </div>

        <div class="col-12 document-type-type-select">
            <form-select
                    name="type"
                    label="type"
                    :options="types"
                    :allow-empty="false"
                    :on-input="onTypeSelected"
                    :loading="!types.length"
                    track-by="id"
                    ref="typeSelect"
                    autocomplete="off"
            >
            </form-select>
        </div>

        <div class="col-12" v-if="types.length && (id || is_new) && !retrieving">
            <div class="row">
                <div class="col-12">
                    <form-input :form="form" type="text" name="name" required/>
                </div>

                <div class="col-12">
                    <form-textarea :form="form" name="description" rows="6"/>
                </div>

                <div class="col-12">
                    <backend-select :error="form.errors.get('roles')" :value="field('roles')" v-model="form.roles"
                                    :route="route('roles.index')" return="id" name="roles" label="roles" multiple/>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <input :disabled="form.busy" type="button" @click.prevent="store" class="btn btn-brand"
                               :value="isUpdate() ? uLang('app.save') : uLang('app.add_type', { type: lang('app.type')})"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 text-center" v-if="retrieving">
            <i class="fa fa-3x fa-spin fa-circle-o-notch"></i>
        </div>
    </div>
</template>

<script>
    import { DestroyAlert } from '~/Swals'
    import Form from "~/Form/Form";
    import FormMixin from '~/mixins/form';
    import MultiSelect from 'vue-multiselect'

    export default {
        name: "form-setting-types",
        mixins: [FormMixin],

        components: {
            MultiSelect
        },

        props: {
            settingId: {
                required: true,
            },
        },

        data() {
            return {
                id: null,
                entity: 'types',
                form: new Form({
                    name: '',
                    description: '',
                    relation_types: null,
                }),
                types: [],
                type: null,
                is_new: false,
            }
        },

        computed: {
            delete_button_title() {
                if (!(this.id || this.is_new)) {
                    return uLang('app.choose_a_type_to_delete', {type: lang('app.type')});
                } else if (this.is_new) {
                    return uLang('app.select_a_different_type_to_delete_new_type', {type: lang('app.type')});
                } else if (this.id) {
                    if (this.type.deletable) {
                        return uLang('app.delete_type', {type: lang('app.type')});
                    } else {
                        return uLang('app.this_type_isnt_deletable', {type: lang('app.type')});
                    }
                }
            },
        },

        created() {
            this.retrieveTypes();

            this.$on('afterStore', data => {
                this.retrieveTypes(true, data.id);
            });
            this.$on('afterUpdate', data => {
                this.retrieveTypes(true, data.id);
            });
        },

        methods: {
            async retrieveTypes(afterSave, id) {
                let {data} = await window.axios.get(route('types.index'));
                this.types = data;

                let typeSelect = this.$refs.typeSelect;
                if (afterSave) {
                    typeSelect.model = this.types.find(t => t.id === id);
                    this.onTypeSelected(typeSelect.model);
                }
            },

            async deleteCurrent() {
                new DestroyAlert({ entity: this.lang('app.type') }).show().then(async () => {
                    let response = await window.axios.delete(route('types.destroy', { type: this.id }));

                    await this.clearForm();

                    this.retrieveTypes();
                });
            },

            createNew() {
                // Show form for when item is new
                this.is_new = true;

                this.clearForm();
            },

            async clearForm() {
                // Set selected type to null
                this.$refs.typeSelect.model = null;

                // Reset the data
                this.id = null;
                this.type = null;
                this.form.name = '';
                this.form.description = '';
                this.form.roles = null;
            },

            onTypeSelected(val) {
                this.is_new  = false;
                if (val !== null) {
                    this.id = val.id;
                    this.type = val;
                    this.retrieve();
                } else {
                    this.type = null;
                }
            },
        },
    }
</script>
